import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
  margin-bottom: 2rem;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  display: flex;
  .matches-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    height: 15%;
    h2 {
      color: #ff6a00;
    }
    .circle {
      position: relative;
      top: 5px;
      left: 5px;
      text-align: center;
      width: 60px;
      height: 60px;
      border-radius: 100%;
      background-color: #ffffff;
    }
    .circle p {
      position: absolute;
      top: 10%;
      left: 35%;
      cursor: default;
    }
    .circle-border {
      position: relative;
      text-align: center;
      width: 70px;
      height: 70px;
      border-radius: 100%;
      background-color: #e53b3b;
    }
    .hover-information {
      display: none;
      width: 200px;
      height: fit-content;
      padding: 0.5rem;
      border-radius: 24px;
      color: #fff;
      background: #000;
      position: absolute;
      bottom: 100%;
      right: 0;
    }
    .circle-border:hover > .hover-information {
      display: block;
    }
  }
  .stats-table-header {
    width: 100%;
    height: 3%;
    background: #eee;
    padding: 0.5rem 0;
    text-align: center;
  }
  .stats-table-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 60%;
    .data-object {
      width: 25%;
      height: 15%;
      text-align: center;
      flex-shrink: 1;
    }
    .data-value {
      color: #555;
      font-weight: 700;
    }
  }
  .stats-table-footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 20%;
    .title {
      width: 100%;
      text-align: center;
      background: #eee;
      padding: 0.5rem;
    }
    .data-object {
      width: 25%;
      text-align: center;
    }
  }
  @media only screen and (min-width: 867px) {
    height: ${(props) => (props.isDnD ? "100%" : "100")};
    max-width: ${(props) => (props.isDnD ? "100%" : "calc(30% + 2rem)")};
    width: ${(props) => (props.isDnD ? "100%" : "calc(30% + 2rem)")};
  }
`;
